import jsPDF from "jspdf";
import "jspdf-autotable";
import { toast } from "sonner";

export const exportToPDF = async (
  granted,
  registeredGames,
  totalTrafic,
  quarterlyRevenue,
  pastWeekDonations,
  toppersReportData,
  adViewCompletionData,
  adViewPerGameData
) => {
  if (!granted?.some((g) => g.type === "download-pdf")) {
    toast.error("You don't have neccessary permissions to do this operation!", {
      duration: 3000,
    });
    return;
  }
  await exportGamesCountToPDF(registeredGames);
  await userTrafficToPDF(totalTrafic);
  await quarterlyRevenueToPDF(quarterlyRevenue);
  await donationsToPDF(pastWeekDonations);
  await toppersReportToPDF(toppersReportData);
  await exportAdsCompletionRateData(adViewCompletionData);
  await exportAdsCountsPerMonth(adViewPerGameData);
};

const exportGamesCountToPDF = async (registeredGames) => {
  const doc = new jsPDF();

  doc.text("Games By Categories Data", 14, 10);

  const headers = [["Game Type", "Total Games", "Percentage"]];
  const totalCount = registeredGames.reduce((sum, game) => sum + game.count, 0);
  const newData = registeredGames.map((m) => ({
    ...m,
    percentage: `${Math.floor((m.count / totalCount) * 100)}%`,
  }));

  const data = newData.map(({ category, count, percentage }) => [
    category,
    count,
    percentage,
  ]);

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("Games-By-Categories-Data.pdf");
};

const userTrafficToPDF = async (totalTrafic) => {
  const doc = new jsPDF();

  doc.text("Quarterly User Traffic", 14, 10);

  const headers = [["Year", "Quarter", "Countries", "Provinces", "Cities"]];

  const data = totalTrafic.map(
    ({
      year,
      quarter,
      distinctCountries,
      distinctProvinces,
      distinctCities,
    }) => [year, quarter, distinctCountries, distinctProvinces, distinctCities]
  );

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("Quarterly-User-Traffic.pdf");
};

const quarterlyRevenueToPDF = async (quarterlyRevenue) => {
  const doc = new jsPDF();

  doc.text("Quarterly Revenue Report", 14, 10);

  const headers = [["Date", "Countries", "Provinces", "Cities"]];

  const data = quarterlyRevenue.map(
    ({ date, countries, provinces, cities }) => [
      date,
      countries,
      provinces,
      cities,
    ]
  );

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("Quarterly-Revenue-Report.pdf");
};

const donationsToPDF = async (pastWeekDonations) => {
  const doc = new jsPDF();

  doc.text("Weekly Donations Report", 14, 10);

  const headers = [["Date", "Countries", "Provinces", "Cities"]];

  const data = pastWeekDonations.map(
    ({ date, countries, provinces, cities }) => [
      date,
      countries,
      provinces,
      cities,
    ]
  );

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("Weekly-Donations-Report.pdf");
};

const toppersReportToPDF = async (toppersReportData) => {
  const doc = new jsPDF();

  doc.text("Global Users Report", 14, 10);

  const headers = [["Country Name", "Country Code", "Users"]];

  const data = toppersReportData.map(({ name, country, value }) => [
    name,
    country,
    value,
  ]);

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("Global-Users-Report.pdf");
};

const exportAdsCompletionRateData = async (adViewCompletionData) => {
  const doc = new jsPDF();

  doc.text("Ads Completion Per Game", 14, 10);

  const headers = [
    ["Game", "Total Ads", "Completely Watched", "Skipped", "Completion Rate"],
  ];
  const newData = adViewCompletionData.map((item) => ({
    ...item,
    percentage: `${((item.watched_ads / item.total_ads) * 100).toFixed(1)}%`,
  }));
  const data = newData.map(
    ({ game_title, total_ads, watched_ads, skiped_ads, percentage }) => [
      game_title,
      total_ads,
      watched_ads,
      skiped_ads,
      percentage,
    ]
  );
  console.log("Data :", data);

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("Ads-Completion-Per-Game.pdf");
};

const exportAdsCountsPerMonth = async (adViewPerGameData) => {
  const doc = new jsPDF();

  doc.text("Ads Counts Data", 14, 10);

  if (!adViewPerGameData || adViewPerGameData.length === 0) {
    console.warn("No data found");
    return;
  }

  const months = adViewPerGameData[0].data.map((d) => d.date);

  const headers = [["Game", ...months]];

  const data = adViewPerGameData.map((game) => {
    const row = [game.title];
    months.forEach((month) => {
      const monthData = game.data.find((d) => d.date === month);
      row.push(monthData ? monthData.total_ads : 0);
    });
    return row;
  });

  console.log("Headers:", headers);
  console.log("Data:", data);

  doc.autoTable({
    startY: 20,
    head: headers,
    body: data,
  });

  doc.save("ads-counts-data.pdf");
};
